import React, { useContext, useState } from "react";
import { Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { Grid2 as Grid } from "@mui/material";
import { useUsers } from "../hooks/useUsers";
import { ToastContext } from "../context/ToastContext";
import { useAddEmailAction } from "../hooks/useAddEmailAction";
import { useEmailActions } from "../hooks/useEmailActions";
import { useEmailId } from "../hooks/useEmailId";
import { useIsInSharedInbox } from "../hooks/useIsInSharedInbox";
import { useTaskpaneTelemetry } from "../telemetry/useTaskpaneTelemetry";

const AssignButton: React.FC<{ contactId?: string }> = ({ contactId }) => {
  const { trackEmailAssignSucceeded, trackEmailAssignFailed } = useTaskpaneTelemetry();
  const emailId = useEmailId();
  const isInSharedInbox = useIsInSharedInbox();
  const { users } = useUsers();
  const { addEmailAction, reAssignEmailAction } = useAddEmailAction();
  const { emailActions, mutate } = useEmailActions();
  const { showToast } = useContext(ToastContext);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAssign = async (userId: string) => {
    if (!emailId) return;
    const isReassign = !!emailActions?.assignedTo;
    try {
      if (isReassign) {
        await reAssignEmailAction({
          externalIds: [emailId],
          userId: userId,
        });
      } else {
        await addEmailAction({
          externalId: emailId,
          type: "Email",
          assignedToUserId: userId,
          contactId: contactId,
        });
      }

      mutate();
      showToast("Email assigned", "success");
      trackEmailAssignSucceeded({ is_reassign: String(isReassign) });
    } catch (e) {
      trackEmailAssignFailed({
        is_reassign: String(isReassign),
        error: e instanceof Error ? e.message : String(e),
      });
    }
  };
  return (
    <Grid size="grow" height="100%">
      <Button
        variant="contained"
        sx={{ height: "100%" }}
        size="small"
        onClick={handleClick}
        fullWidth={true}
        disabled={!isInSharedInbox}
      >
        {emailActions?.assignedTo ? (
          <Stack>
            <Typography sx={{ fontSize: 10, position: "absolute", top: 0, left: 0, right: 0, textAlign: "center" }}>
              Assigned to
            </Typography>
            <Typography sx={{ fontSize: 12, marginTop: 1 }}>{emailActions?.assignedTo.fullName}</Typography>
          </Stack>
        ) : (
          "Assign"
        )}
      </Button>
      <Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
        {users?.map((user) => (
          <MenuItem
            key={user.id}
            onClick={() => {
              handleAssign(user.id);
              handleClose();
            }}
          >
            {user.fullName}
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
};

export default AssignButton;
